<template>
    <label class="radio">
        <input class="radio__input" :name="props.name" type="radio" :checked="props.checked"
        @change="$emit('change')">
        <span class="radio__check">
      <slot name="content">
        {{ props.label }}
      </slot>
    </span>
    </label>
</template>

<script setup>
defineEmits(['change']);

const props = defineProps({
    label: {
        type: String,
        default: ''
    },
    name: {
        type: String,
        required: true,
    },
    value: {
        type: Boolean,
        default: false
    },
    checked: {
        type: Boolean,
        default: false
    }
})
</script>